import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent {
  title = 'app';
  showHeader = true;


modifyHeader(location) {
  if (location.url !== '/LogACod' && location.url !== '/home') {
    this.showHeader = false;
  } else {
    this.showHeader = true;
  }
}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts